__turbopack_context__.v({
  "container": "TilesSection-module-scss-module__z3xmfG__container",
  "tile": "TilesSection-module-scss-module__z3xmfG__tile",
  "tiles": "TilesSection-module-scss-module__z3xmfG__tiles",
});
